// src/components/common/Button.jsx
import React from "react";
import { motion } from "framer-motion";

const Button = ({
  type = "button",
  variant = "primary",
  size = "md",
  children,
  className = "",
  icon,
  iconPosition = "right",
  ...rest
}) => {
  const baseStyles =
    "relative inline-flex items-center justify-center font-medium rounded-lg transition-all duration-300 overflow-hidden group";

  const variants = {
    primary:
      "bg-gradient-to-r from-blue-600 to-purple-600 text-white hover:shadow-lg hover:shadow-blue-500/25",
    secondary:
      "bg-white/10 backdrop-blur-sm border border-white/20 text-white hover:bg-white/20 hover:border-white/30",
    outline:
      "bg-transparent border-2 border-blue-500 text-blue-400 hover:bg-blue-500/10 hover:border-blue-400",
    ghost: "bg-transparent text-gray-300 hover:text-white hover:bg-white/10",
    vxdf: "bg-gradient-to-r from-blue-600 to-purple-600 text-white hover:shadow-lg hover:shadow-purple-500/25",
  };

  const sizes = {
    sm: "px-4 py-2 text-sm gap-2",
    md: "px-6 py-2.5 text-base gap-2",
    lg: "px-8 py-3 text-lg gap-3",
  };

  const iconElement = icon && (
    <span
      className={`transition-transform duration-300 ${
        variant === "primary" || variant === "vxdf"
          ? "group-hover:translate-x-1"
          : ""
      }`}
    >
      {icon}
    </span>
  );

  return (
    <motion.button
      type={type}
      className={`${baseStyles} ${variants[variant]} ${sizes[size]} ${className}`}
      whileHover={{ scale: 1.02 }}
      whileTap={{ scale: 0.98 }}
      {...rest}
    >
      {/* Gradient overlay for primary and vxdf variants */}
      {(variant === "primary" || variant === "vxdf") && (
        <div
          className={`absolute inset-0 bg-gradient-to-r ${
            variant === "vxdf"
              ? "from-purple-600 to-blue-600"
              : "from-purple-600 to-blue-600"
          } opacity-0 group-hover:opacity-100 transition-opacity`}
        />
      )}

      {/* Content */}
      <span className="relative z-10 flex items-center gap-2">
        {iconPosition === "left" && iconElement}
        {children}
        {iconPosition === "right" && iconElement}
      </span>
    </motion.button>
  );
};

export default Button;
